import React from "react";

const LangContext = React.createContext("languageContext");

export default LangContext;
